import React, { useContext } from "react";
import PropTypes from "prop-types";
import useReportsData from "./data/useReportsData";
import UseEmployeeData from "./data/UseEmployeeData";
import UseBusinessData from "./data/UseBusinessData";
import useScheduleData from "./data/useScheduleData";
import UseInventoryData from "./data/UseInventoryData";
import useBusinessSetting from "./data/useBusinessSetting";
import useIntegrationData from "./data/useIntegrationData";
import useMediaData from "./data/UseMediaData";
import useDashboardData from "./data/UseDashboardData";
import UseAcl from "./data/UseAcl";
import useDailyReports from "./data/useDailyReports";
import useAggregateReports from "./data/useAggregateReports";
import useShiftReports from "./data/useShiftReports";
import useStaffTimesheets from "./data/useStaffTimesheets";
import usePrepaidItems from "./data/usePrepaidItems";
import usePaymentReports from "./data/usePaymentReport";
import UseUsersData from "./data/UseUsersData";
import useWaiversData from "./data/useWaiversData";
import useCustomerSegment from "./data/useCustomerSegment";
import UseEmbedMode from "./data/UseEmbedMode";
import useCampaigns from "./data/useCampaigns";
import useSurveys from "./data/useSurveys";
import useTags from "./data/useTags";

const appDataContext = React.createContext({});
const { Provider } = appDataContext;

const useAppDataProvider = () => {
  const userAcl = UseAcl();
  const reports = useReportsData(userAcl);
  const employees = UseEmployeeData();
  const business = UseBusinessData();
  const schedule = useScheduleData();
  const inventory = UseInventoryData();
  const businessSetting = useBusinessSetting();
  const integration = useIntegrationData();
  const dashboard = useDashboardData();
  const media = useMediaData();
  const dailyReports = useDailyReports();
  const aggregateReports = useAggregateReports();
  const shiftReports = useShiftReports();
  const staffTimesheets = useStaffTimesheets();
  const prepaidItems = usePrepaidItems();
  const webPaymentReport = usePaymentReports();
  const userManagement = UseUsersData();
  const waivers = useWaiversData();
  const customerSegments = useCustomerSegment();
  const embedData = UseEmbedMode();
  const campaignsData = useCampaigns();
  const surveysData = useSurveys();
  const tagsData = useTags();

  return {

    tagsData,
    reports,
    employees,
    business,
    schedule,
    inventory,
    businessSetting,
    integration,
    media,
    dashboard,
    userAcl,
    dailyReports,
    aggregateReports,
    shiftReports,
    staffTimesheets,
    prepaidItems,
    webPaymentReport,
    userManagement,
    waivers,
    customerSegments,
    embedData,
    campaignsData,
    surveysData
  };
};

export const AppDataProvider = ({ children }) => {
  const data = useAppDataProvider();
  return <Provider value={data}>{children}</Provider>;
};

AppDataProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

export const useAppData = () => useContext(appDataContext);
